var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5522 0.851562C12.5999 0.851562 12.6477 0.851562 12.6981 0.851562C12.8152 2.29815 12.2631 3.37903 11.592 4.16177C10.9336 4.93911 10.0319 5.69303 8.57365 5.57863C8.47637 4.15277 9.02942 3.15205 9.69957 2.37111C10.3211 1.64331 11.4605 0.995681 12.5522 0.851562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9653 15.9072C16.9653 15.9216 16.9653 15.9342 16.9653 15.9477C16.5554 17.189 15.9709 18.2527 15.2575 19.2399C14.6063 20.1362 13.8082 21.3423 12.3832 21.3423C11.1519 21.3423 10.3341 20.5505 9.07212 20.5289C7.73723 20.5073 7.00313 21.1909 5.78263 21.363C5.64301 21.363 5.5034 21.363 5.36648 21.363C4.47025 21.2333 3.74696 20.5235 3.22003 19.884C1.66625 17.9942 0.46557 15.5532 0.242188 12.4295C0.242188 12.1232 0.242188 11.8179 0.242188 11.5116C0.336765 9.27598 1.42305 7.45829 2.86694 6.57737C3.62896 6.10898 4.67652 5.70996 5.84297 5.8883C6.34288 5.96577 6.8536 6.13691 7.30127 6.30624C7.72552 6.46928 8.25605 6.75841 8.75866 6.7431C9.09914 6.73319 9.43782 6.55575 9.781 6.43055C10.7862 6.06755 11.7716 5.65141 13.0705 5.84687C14.6315 6.08286 15.7394 6.77643 16.4239 7.84651C15.1035 8.68689 14.0595 9.95333 14.2379 12.116C14.3964 14.0805 15.5385 15.2299 16.9653 15.9072Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.535564fe2ed72923951f131cbb3e09e3.svg";
export { ForwardRef as ReactComponent };